import styled from "styled-components";

export const NotFoundContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 80px 20px;
  text-align: center;

  .code {
    font-size: 3rem;
    font-weight: 700;
    opacity: 0.35;
  }

  .message {
    font-size: 1.1rem;
  }

  .hint {
    font-size: 0.9rem;
    opacity: 0.6;
  }

  a {
    margin-top: 8px;
    text-decoration: underline;
  }
`;
